import { Injectable } from '@angular/core';
import Swal from 'sweetalert2'
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class AlertService {

  constructor(private translateService: TranslateService) {

  }

  show(message) {
    Swal.fire({text: this.translateService.instant(message), heightAuto: false });
  }

  showTitle(title, message) {
    Swal.fire({ title: title, text: this.translateService.instant(message), heightAuto: false });
  }

  showHtml(title, message) {
    Swal.fire({ title: this.translateService.instant(title), html: this.translateService.instant(message), heightAuto: false });
  }

  showError(message) {
    Swal.fire({ title:this.translateService.instant('TransactionError'), text: this.translateService.instant(message), icon: "error", heightAuto: false });

  }

  askQuestionWithRange(title, text, inputAttributes, inputValue) {
    return new Promise((resolve, reject) => {
      resolve(
        Swal.fire({
          title: title,
          text: text,
          input: 'range',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          inputAttributes: inputAttributes,
          inputValue: inputValue,
          confirmButtonText: this.translateService.instant("DialogYesNo.Button.Yes"),
          cancelButtonText: this.translateService.instant("DialogYesNo.Button.No"),
          heightAuto: false,
          inputValidator: (value) => {
            if (!value) {
              return 'Le champ ne peut être vide'
            }
          }
        }))
    })
  }

  askQuestion(title, text, input) {
    return new Promise((resolve, reject) => {
      resolve(
        Swal.fire({
          title: title,
          text: text,
          input: input, // 'text'or 'number'
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateService.instant("DialogYesNo.Button.Yes"),
          cancelButtonText: this.translateService.instant("DialogYesNo.Button.No"),
          heightAuto: false,
          inputValidator: (value) => {
            if (!value) {
              return 'Le champ ne peut être vide'
            }
          }
        }))
    })
  }

  ShowQuestion(title, text) {
    return new Promise((resolve, reject) => {
      resolve(
      Swal.fire({
        title: this.translateService.instant(title),
        text: this.translateService.instant(text),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.translateService.instant("DialogYesNo.Button.Yes"),
        cancelButtonText: this.translateService.instant("DialogYesNo.Button.No"),
        heightAuto: false
      }))
    })
  }
}
